import CandidateFile from "#candidate/pages/CandidateFile"
import CandidateWorkHistory from "#candidate/pages/CandidateWorkHistory"
import AccordionMain from "#core/components/accordion/Accordion"
import { useState } from "react"
import CandidateDetailsEvaluation from "./CandidateDetailsEvaluation"
import { useCandidateRedux } from "#candidate/redux/slice"
import { STATUS } from "#candidate/constants"

export default function CandidateDetailsAccordion() {
	const { candidate } = useCandidateRedux()
	const [select, setSelect] = useState(false)

	const items = [
		{
			id: "files",
			label: "Archivos",
			component: <CandidateFile autoFetch={select === "files"} />,
		},
	]
	if (![STATUS.SCHEDULED_BY_HR].includes(candidate.status)) {
		items.unshift({
			id: "Historial laboral",
			label: "Historial laboral",
			component: <CandidateWorkHistory autoFetch={select === "Historial laboral"} />,
		})
		items.unshift({
			id: "Entrevistas",
			label: "Entrevistas",
			component: <CandidateDetailsEvaluation autoFetch={select === "Entrevistas"} />,
		})
	}

	return <AccordionMain items={items} getSelect={setSelect} />
}
